import { render, staticRenderFns } from "./Form-Preview.vue?vue&type=template&id=6bab4db3&scoped=true"
import script from "./Form-Preview.vue?vue&type=script&lang=js"
export * from "./Form-Preview.vue?vue&type=script&lang=js"
import style0 from "./Form-Preview.vue?vue&type=style&index=0&id=6bab4db3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bab4db3",
  null
  
)

export default component.exports